import router, { somenteNaoAutenticado, somenteAutenticado } from '@/router'
import Home from '../views/home/Home.vue'

router.addRoutes([
  {
    path: '/',
    name: 'rota-login',
    component: Home,
    beforeEnter: somenteNaoAutenticado,
  },
  {
    path: '/dashboard',
    name: 'rota-dashboard',
    beforeEnter: somenteAutenticado,
    meta: {
      layout: 'LayoutBarraLateral',
    },
    component: () => import(/* webpackChunkName: "atendimento" */ '../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/usuario/restaurar/:id',
    name: 'rota-restaurar-senha',
    meta: {
      titulo: 'Restaurar senha',
    },
    component: () => import(/* webpackChunkName: "atendimento" */ '../views/recuperar-senha/RecuperarSenha.vue'),
    beforeEnter: somenteNaoAutenticado,
  },
  {
    path: '*',
    redirect: {
      name: 'rota-login',
    },
  },
])
